import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ButtonGroup, Col, Container, Row, ToggleButton } from "react-bootstrap";
import { textFilter } from "react-bootstrap-table2-filter";
import Button from "react-bootstrap/Button";
import { withTranslation } from "react-i18next";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import StorageService from "../../../../services/StorageService";
import AllowedUrlsActionCell from "./deniedUrlsActionCell/DeniedUrlsActionCell";
import AddAllowedUrlDialog from "./dialogs/addDeniedUrlDialog/AddDeniedUrlDialog";
import DeleteAllowedUrlDialog from "./dialogs/deleteDeniedUrlDialog/DeleteDeniedUrlDialog";
import PaginationTableFilterToggle
  from "../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class DeniedUrlsTab extends React.Component {
  tableId = "deniedUrlsTabTable";
  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      allowedUrls: this.props.networkProfile.denyProxyUrls,
      apiError: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      showAddDeniedUrlModal: false,
      showDeleteDeniedUrlModal: false
    };

    this.handleDeleteDeniedUrl = this.handleDeleteDeniedUrl.bind(this);
    this.handleAddDeniedUrl = this.handleAddDeniedUrl.bind(this);
  }

  async handleAddDeniedUrl(url) {
    const networkProfile = Object.assign({}, this.props.networkProfile);
    networkProfile["denyProxyUrls"] = [
      ...new Set([...this.props.networkProfile.denyProxyUrls, url])
    ];
    if (this.props.onSubmit(networkProfile))
      this.setState({ showAddDeniedUrlModal: false });
  }

  async handleDeleteDeniedUrl() {
    const networkProfile = Object.assign({}, this.props.networkProfile);
    networkProfile["denyProxyUrls"] = [
      ...new Set(
        this.props.networkProfile.denyProxyUrls.filter(
          u => u !== this.state.selectedUrl
        )
      )
    ];
    if (this.props.onSubmit(networkProfile))
      this.setState({ showDeleteDeniedUrlModal: false });
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "url",
        text: t("SingleNetworkProfile.DeniedUrlsTab.ColumnUrl"),
        sort: true,
        filter: textFilter({
          placeholder: t(
            "SingleNetworkProfile.DeniedUrlsTab.FilterUrlPlaceholder"
          ),
          style: { display: this.state.displayFilter }
        })
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, row) => (
          <AllowedUrlsActionCell
            onDelete={() =>
              this.setState({
                showDeleteDeniedUrlModal: true,
                selectedUrl: row.url
              })
            }
          />
        )
      }
    ];

    return (
      <div>
        <DeleteAllowedUrlDialog
          show={this.state.showDeleteDeniedUrlModal}
          dialogApiError={this.props.dialogApiError}
          onHide={() => this.setState({ showDeleteDeniedUrlModal: false })}
          onSubmit={this.handleDeleteDeniedUrl}
        />
        <AddAllowedUrlDialog
          show={this.state.showAddDeniedUrlModal}
          dialogApiError={this.props.dialogApiError}
          onHide={() => this.setState({ showAddDeniedUrlModal: false })}
          onSubmit={this.handleAddDeniedUrl}
        />
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="mt-3">
            <Col>
              <h4>{t("SingleNetworkProfile.DeniedUrlsTab.Title")}</h4>
            </Col>
            <Col>
              <Button
                className="btn btn-green"
                style={{ float: "right" }}
                onClick={() => this.setState({ showAddDeniedUrlModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                {t("SingleNetworkProfile.DeniedUrlsTab.Description")}
              </p>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <PaginationTable
                data={this.props.networkProfile.denyProxyUrls.map(p => ({ url: p }))}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="url"
                id={this.tableId}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(DeniedUrlsTab);
